import Vue from 'vue'
import Router from 'vue-router'

import protac from '@/views/protac.vue';
import contact from '@/views/contact.vue'
import testimonial from '@/views/testimonial.vue'
import services from '@/views/services.vue'
import about from '@/views/about.vue'
import detail from '@/views/detail.vue'
import product from '@/views/product.vue'
import productView from '@/views/productView.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    { path: '*', redirect: '/protac' },
    { path: '/protac', name: 'protac', component: protac },
    { path: '/contact', name: 'contact', component: contact, },
    { path: '/testimonial', name: 'testimonial', component: testimonial, },
    { path: '/about', name: 'about', component: about, },
    { path: '/detail', name: 'detail', component: detail, },
    { path: '/product', name: 'product', component: product, },
    { path: '/services', name: 'services', component: services, },
    { path: '/productView', name: 'productView', component: productView, },

  ]
})